angular.module('rjmNg.directives').directive 'saveFigure', [
  "figureService"
  "utils"
  (figureService, utils) ->
    restrict:"E"
    templateUrl: "directive.saveFigure.html"
    replace: true
    priority: 200
    scope:
      figure: "=currentFigure"
      dashboard: "="
      scalars: "="
      saveSuccessCallback: "="
      saveErrorCallback: "="
      savingInProgress: "="
      stopSave: "="
      errorMessage: "="
      selectedMetrics: "="
      figureIsUnused: "="
    controller: [
      "$scope"
      "$element"
      "$attrs"
      "$location"
      "Figures"
      "Charts"
      "DashboardItem"
      "app"
      "notification"
      "figureEnums"
      "reportBuilder"
      "$routeParams"
      "modelRequestEnum"
      "reportQueryType"
      "enums"
      "appRoute"
      "Rjql"
      "logger"
      (
        $scope
        $element
        $attrs
        $location
        Figures
        Charts
        DashboardItem
        app
        notification
        figureEnums
        reportBuilder
        $routeParams
        modelRequestEnum
        reportQueryType
        enums
        appRoute
        Rjql
        logger
      ) ->
        RJQL_VERSION = app.getRjqlVersion()

        $scope.canSave = false
        $scope.canUpdate = false
        $scope.tooltip = null
        # This currently doesn't control any UI due to confusion during testing.
        $scope.showNumberWarning = false
        $scope.duplicateName = false

        # We don't want to allow the user to click save before the
        # state has been reset at least once.
        $scope.stateHasBeenReset = false

        # Make a list of dashboards we can send charts to, but only include user owned dashboards
        $scope.dashboards = (dashboard for dashboard in app.getDashboards() when dashboard.is_syndicated is false or dashboard.permission is enums.DASHBOARD_PERMISSION.EDIT)

        # Handle error response for saving a figure
        _saveOrUpdateError = (errorResponse) ->
          $scope.savingInProgress = false
          if errorResponse.data?.code is figureEnums.ERROR_CODES.DUPLICATE_NAME
            $scope.duplicateName = true
          else if errorResponse.data?.error?
            notification.error("Save Figure Error", errorResponse.data.error, "global")
          else
            notification.error("Save Figure Error", "There was an error saving this figure.", "global")
          _invokeErrorCallback()

        # Handle success response for saving a figure
        _saveOrUpdateSuccess = (successResponse) ->
          figureId = successResponse.id
          getData = RJQL_VERSION isnt 1.0
          requestOptions = Figures.getRequestOptions(getData, true)
          angular.extend(requestOptions, {timeout: modelRequestEnum.TIMEOUTS.MAX_POLLING_INTERVAL_SECS * 1000})

          if RJQL_VERSION is 1.0
            Figures.get(figureId, true, requestOptions).then (response) ->
              _queueRjqlCacheJob(successResponse.rjqlId)
          else
            # Calling get again populates the Figures cache with the updated figure.
            Figures.get(figureId, true, requestOptions).then (response) ->
              # This will re-populate the Add Report list with the new figure.  We'll need
              # to move this into figure model once we are in a post-NewChart world.
              Charts.getCharts(true)

          # Send save event to the journal
          $scope._logEvent(successResponse.reportQueryType, figureId)

          _invokeSuccessCallback(successResponse, $scope.selectedDashboard)

        # In scope only for tests
        $scope._logEvent = (queryType, figureId) ->
          if queryType is reportQueryType.SQL
            prefix = 'SQL '
          else
            prefix = if figureService.isCohortFigure($scope.figure) then 'Cohort ' else ''

          if $scope.dashboard?
            logger.log("#{prefix}Report Builder Usage", "Save", 1, "edit")
          else
            logger.log("#{prefix}Report Builder Usage", "Save", 1, "create")

        _queueRjqlCacheJob = (rjqlId) ->
          Rjql(app.getClientId()).createRjqlJobs([rjqlId]).then () ->
            Charts.getCharts(true)

        # Creates a dashboard item on a dashboard and then moves there once it's ready
        _createDashboardItem = (figureId, dashboardId) ->
          resourceParams =
            clientId: app.getClientId()
            id: null

          dashboardItem =
            clientId: app.getClientId()
            id: null
            figureId: figureId
            chartId: null # If a chartId exists for this figure, the PHP controller will set this
            dashId: dashboardId

          if $routeParams.row?
            row = parseInt($routeParams.row)
            if not isNaN(row)
              dashboardItem.row = row
              dashboardItem.column = 1

          DashboardItem.save(resourceParams, dashboardItem, (successResponse) ->
            null
          , (errorResponse) ->
            notification.error("Save to Dashboard Error", "There was an error saving to a dashboard", "global")
            _invokeErrorCallback()
          )

        # Handles re-saving an existing figure with a new name/type
        _reSave = (figure, name, type) ->
          figure.name = name
          figure.presentationType =
            id: type
          return _saveOrCreateFigure(figure)

        # Handles saving an existing figure as a new figure with a name/type
        _saveAs = (figure, name, type) ->
          figure.id = null
          figure.rjqlId = null
          figure.name = name
          figure.presentationType =
            id: type
          return _saveOrCreateFigure(figure)

        # Save or create a figure (null id signifies a create)
        _saveOrCreateFigure = (figure) ->
          delete figure.data #no need to pass along the data
          if figure.id?
            return Figures.save(figure)
          else
            return Figures.create(figure)


        _getLoadedFigureStateId = ->
          loadedFigureStateId = "Chart"
          unless $scope.figure.presentationType?
            $scope.figure.presentationType =
              id: figureEnums.PRESENTATION_TYPES.HIGHCHARTS

          presType = $scope.figure.presentationType.id
          queryType = $scope.figure.reportQueryType

          if presType is figureEnums.PRESENTATION_TYPES.TABLE
            loadedFigureStateId = "Table"
          else if presType is figureEnums.PRESENTATION_TYPES.SCALAR
            loadedFigureStateId = _getLoadedFigureStateIdForScalar(queryType, $scope.startingFigure)

          return loadedFigureStateId

        _getLoadedFigureStateIdForScalar = (queryType, figure) ->
          switch queryType
            when reportQueryType.RJQL
              if figureService.isSingleSourceFigure($scope.startingFigure)
                loadedFigureStateId = "Number: #{$scope.startingFigure.query.from.alias}"
              else
                loadedFigureStateId = "Number: #{$scope.startingFigure.query.select.measures[0].label}"
            when reportQueryType.SQL
              # SQL Reports are saved as scalars automatically
              loadedFigureStateId = "Table"
          return loadedFigureStateId

        #######################################################
        # Directive Controller Scope                          #
        #######################################################

        $scope.startingFigure = null
        $scope.selectedDashboard = null
        $scope.figureSaveStates = null
        $scope.selectedFigureState = null
        $scope.userHasChangedFigureState = false
        $scope.savingInProgress = false
        figureIsUnused = false

        _hasNoVisibleMetrics = () ->
          if $scope.figure?.reportQueryType isnt reportQueryType.RJQL
            return false

          if $scope.selectedMetrics?
            for metric in $scope.selectedMetrics
              if metric.plot
                return false

          return true

        $scope.updateUI = ->
          $scope.canSave = true
          $scope.canUpdate = true
          $scope.tooltip = null
          $scope.showNumberWarning = false

          noVisibleMetrics = _hasNoVisibleMetrics()

          [dimensionOrderingValid, invalidDimensionOrderingMetric] = reportBuilder.dimensionSortingIsValid $scope.selectedMetrics
          $scope.canUpdate = _isNameSet($scope.figure?.name) and not $scope.duplicateName and not noVisibleMetrics and dimensionOrderingValid and not $scope.stopSave
          $scope.canSave = _isNameSet($scope.figure?.name) and not ($scope.figure?.name is $scope.originalFigureName and $scope.figure?.id?) and not noVisibleMetrics and dimensionOrderingValid and not $scope.stopSave
          restrictions = []

          warningIcon = "<br><span class=\"rj-icon--warning\"></span>&nbsp;"

          if not _isNameSet($scope.figure?.name)
            restrictions.push(warningIcon + 'To save this figure, give it a name.')
          else if $scope.figure?.name is $scope.originalFigureName
            restrictions.push(warningIcon + 'To save a copy of this figure, give it a unique name.')
          else if $scope.duplicateName
            restrictions.push(warningIcon + 'A report with this name already exists.')

          if noVisibleMetrics
            restrictions.push(warningIcon + 'All of your metrics are hidden. To save this figure, make at least one metric visible.')

          if not dimensionOrderingValid
            restrictions.push(warningIcon + "To save, choose a sorting dimension for '#{invalidDimensionOrderingMetric.alias}'.")

          if $scope.stopSave is true
            restrictions.push(warningIcon + $scope.errorMessage)

          if restrictions.length > 0
            $scope.tooltip = restrictions.join()

          # Determine whether to show the "This will only save the number you've selected" warning label
          if $scope.selectedFigureState?.type is figureEnums.PRESENTATION_TYPES.SCALAR
            $scope.showNumberWarning = true

        $scope.$watch "selectedFigureState", (newState, old) ->
          $scope.updateUI()

        # Resets all possible figure save states
        $scope.resetState = ->
          $scope.savingInProgress = false
          initialFigureIsChart = $scope.figure.presentationType?.id is figureEnums.PRESENTATION_TYPES.HIGHCHARTS
          initialFigureIsTable = $scope.figure.presentationType?.id is figureEnums.PRESENTATION_TYPES.TABLE
          loadedFigureStateId = _getLoadedFigureStateId()

          $scope.updateUI()

          # Chart figure state
          chartSaveState =
            type: figureEnums.PRESENTATION_TYPES.HIGHCHARTS
            id: "Chart"
            figure: $scope.figure

          # Table figure state
          tableSaveState =
            type: figureEnums.PRESENTATION_TYPES.TABLE
            id: "Table"
            figure: $scope.figure

          #Scalar figure states
          scalarSaveStates = []
          # cohort reports shouldn't be able to save as scalars
          if not figureService.isCohortFigure($scope.figure)
            for scalar in $scope.scalars
              scalar.figure.id = $scope.figure.id
              scalar.figure.name = $scope.figure.name

              scalarSaveState =
                type: figureEnums.PRESENTATION_TYPES.SCALAR
                id: "Number: #{scalar.alias}"
                figure: scalar.figure

              scalarSaveStates.push scalarSaveState

          # add them to the list of possible save states
          $scope.figureSaveStates = [chartSaveState, tableSaveState]
          $scope.figureSaveStates = $scope.figureSaveStates.concat(scalarSaveStates)

          # Attempt to use the currently-selected figure state id to set the new
          # selected figure state id. Otherwise, use the default behavior.
          if $scope.userHasChangedFigureState
            if $scope.selectedFigureState?
              statesWithSelectedName = (state for state in $scope.figureSaveStates when state.id is $scope.selectedFigureState.id)
              $scope.selectedFigureState = if statesWithSelectedName.length > 0 then statesWithSelectedName[0] else null
          else
            $scope.selectedFigureState = null

          if not $scope.selectedFigureState?
            if $scope.figure.presentation?.reportBuilder?.chart?.visible == false
              $scope.selectedFigureState = (state for state in $scope.figureSaveStates when state.id is "Table")[0]
            else
              $scope.selectedFigureState = (state for state in $scope.figureSaveStates when state.id is loadedFigureStateId)[0]

          if $scope.dashboard?
            $scope.selectedDashboard = $scope.dashboard
          else
            figureIsUnused = true
            $scope.selectedDashboard = (dashboard for dashboard in $scope.dashboards when dashboard.is_default is 1)[0]

          if !$scope.selectedDashboard # the user has no default dashboard just default to dashboards[0]
            $scope.selectedDashboard = $scope.dashboards[0]

          $scope.stateHasBeenReset = true

          return

        # New figures will have a DataTables state to persist
        _persistTableStateWithFigureId = (figureId, isCopyOrNewFigure) ->
          tempState = localStorage.getItem('RJM_DataTables_temp')
          if tempState?
            localStorage.removeItem('RJM_DataTables_temp')
            localStorage.setItem('RJM_DataTables_' + figureId, tempState)

          if isCopyOrNewFigure and $scope.startingFigure?
            copiedState = localStorage.getItem('RJM_DataTables_' + $scope.startingFigure.id)
            localStorage.setItem('RJM_DataTables_' + figureId, copiedState)

        _isNameSet = (name) ->
          return name? and name.length > 0

        # Verifies all conditions for saving are met
        _canSave = (isCopyOrNewFigure) ->

          # Make sure resetState has been called at least once
          if not $scope.stateHasBeenReset
            return false

          # Make sure saving isn't possible in certian conditions
          if (isCopyOrNewFigure and not $scope.canSave) or (not isCopyOrNewFigure and not $scope.canUpdate)
            return false

          # last check to make sure the name is at least set before trying to save
          if not _isNameSet($scope.figure.name)
            return false

          if $scope.stopSave
            return false

          return true

        $scope.save = (isCopyOrNewFigure)->
          if not _canSave(isCopyOrNewFigure)
            return

          figureToSave = utils.copy($scope.selectedFigureState.figure)

          if figureToSave.presentation?
            if not figureToSave.presentation.reportBuilder?
              figureToSave.presentation.reportBuilder = {}

            figureToSave.presentation.reportBuilder.metricOrder = $scope.selectedMetrics.map (metric) ->
              metric.alias

          if figureService.shouldConvertToScalar(figureToSave, $attrs.convertSingleTablesToScalars is "true")
            $scope.selectedFigureState.type = figureEnums.PRESENTATION_TYPES.SCALAR

          figureToSave.userId ?= app.getUserId()
          figureToSave.clientId ?= app.getClientId()
          savePromise = null
          $scope.savingInProgress = true

          # save-as the chart
          if isCopyOrNewFigure
            savePromise = _saveAs(figureToSave, $scope.figure.name, $scope.selectedFigureState.type)
            figureIsUsedPromise = savePromise.then( (successResponse) ->
              figureIsUnused = false
              _saveOrUpdateSuccess(successResponse)
            ,
            _saveOrUpdateError)

          # re-save the chart
          else
            savePromise = _reSave(figureToSave, $scope.figure.name, $scope.selectedFigureState.type)
            savePromise.then _saveOrUpdateSuccess, _saveOrUpdateError

          savePromise.then (response) ->
            $scope.figure.presentationType = response.presentationType
            _persistTableStateWithFigureId(response.id, isCopyOrNewFigure)
            if isCopyOrNewFigure
              _createDashboardItem(response.id, $scope.selectedDashboard.id)
            else
              _invokeSuccessCallback(response, $scope.selectedDashboard)
            # Hide the save dropdown
            $element.find('.js-action-button-group').removeClass('open')
          # this is necessary for angular 1.6
          # otherwise it will complain that we are not handling rejections
          .catch () ->

        $scope.cancel = () ->
          # Send them back to the dashboard they came from or the default dashboard
          $location.url appRoute("/#{$routeParams.dashboardId ?= ''}")

        _invokeSuccessCallback = (figure, dashboard) ->
          # TODO: update unit tests so figure is non-null
          if figure
            $scope.figure.id = figure.id # figure is null in unit tests
            $scope.figure.rjqlId = figure.rjqlId
            $scope.startingFigure = utils.copy(figure)
            $scope.originalFigureName = figure.name
            $scope.figureIsUnused = figureIsUnused
          $scope.updateUI()
          if $scope.saveSuccessCallback
            $scope.saveSuccessCallback(figure, dashboard)
            $scope.savingInProgress = false

        _invokeErrorCallback = () ->
          $scope.updateUI()
          if $scope.saveErrorCallback
            $scope.saveErrorCallback()

        $scope.updatePerspective = (measure) ->
          $scope.perspective = figureEnums.DATA_PERSPECTIVES[figureService.identifyDataPerspective(measure, RJQL_VERSION)]

    ]
    link: (scope, elem, attrs, controller) ->

      scope.$watch "figure.name", (name, old) ->
        if name isnt old or scope.startingFigure is null
          scope.startingFigure = utils.copy(scope.figure)
          if not scope.originalFigureName?
            scope.originalFigureName = name

        scope.duplicateName = false
        # Update/disable the save buttons
        scope.updateUI()

      scope.$watch "figure.query.select.measures", (newMeasures, oldMeasures) ->
        if newMeasures? and newMeasures.length is 1 and figureService.isCohortFigure(scope.figure)
          scope.updatePerspective(newMeasures[0])
        else
          scope.perspective = null

      scope.$watch "startingFigure", (input,old) ->
        if input is old
          return

        scope.updateUI()

]
